import {nextGUIDId} from "../login/ClientCache";
import {findFieldMetadata} from "../common/Metadata";
import {afterRowInserted, asyncGridAction} from "../actions/BaseDispatcher";
import * as GridAction from "../constants/GridAction";
import {showTooltip} from "../common/TooltipUtil";
import {isKeyEventForBusinessFunction, registeredShortcuts} from "../common/ShortCutsUtil";
import * as BusinessFunction from "../constants/BusinessFunction";
import {NamaKendoWindow, NamaWindowBtnData} from "../views/NamaKendoWindow";
import {addTask, areNotEqual, busy, isNotEmptyOrNull, isNullOrUndefined, removeTask, setFieldValue} from "../common/NamaCommon";
import {IntegerFieldWidget} from "../widgets/IntegerFieldWidget";
import * as KeyboardKeyCode from "../constants/KeyboardKeyCode";
import {gridKey, NamaGridLineEditor} from "./NamaGridLineEditor";
import * as notifier from "../common/ErrorsNotification";
import {translateId} from "../common/Translator";

function grid(element) {
    return $(element).closest("[data-role=grid]").data("kendoGrid");
}

function dateEditor(container, options) {
    $('<input name="' + options.field + '"/>').appendTo(container).kendoDatePicker({
        format: "dd/MM/yyyy",
        parseFormats: ["dd-MM-yyyy", "dd-MM-yy", "dd/MM/yyyy", "dd/MM/yy", "ddMMyyyy", "ddMMyy", "ddMM"]
    });
}

function currentTable(grid) {
    return grid.current().closest("table");
}

export function gridFocusCell(gridWidget, grid, tdIndex, trIndex, callBack, time) {
    setTimeout(() => {
        let currTable = grid.table;
        // let currTable = currentTable(grid);
        let existCell = focusCell(gridWidget, grid, tdIndex, trIndex, currTable, callBack);
        if (!existCell) {
            if (currTable.closest(".k-grid-content-locked").length) {
                currTable = currTable.closest(".k-grid").find(".k-grid-content").find("table");
                focusCell(gridWidget, grid, tdIndex, trIndex, currTable, callBack);
                return;
            }
            console.log("Going to row " + trIndex + ", cell " + tdIndex);
        }
    }, time || 500);
}

function focusCell(gridWidget, grid, tdIndex, trIndex, currTable, callBack) {
    let trExpression = trIndex ? Number.isInteger(trIndex) ? ("tr:eq(" + trIndex + ")") : "tr" + trIndex : "";
    let nextCell = currTable.find(trExpression + " td:eq(" + tdIndex + ")");
    if (nextCell.length) {
        grid.current(nextCell);
        gridWidget.navigateEditorToCurrent();
        if (callBack)
            callBack();
        return true;
    }
    if (callBack)
        callBack();
    return false;
}

export function goToNextRow(e, grid, gridWidget, fromBtnClick) {
    let current = grid.current();
    let currentCellIndex = current.index();
    if (!current.parent().next().length) {
        if (grid.dataSource.page() === grid.dataSource.totalPages()) {
            appendRow(grid, true, gridWidget);
        } else {
            grid.dataSource.page(grid.dataSource.page() + 1);
            gridFocusCell(gridWidget, grid, currentCellIndex, ":first");
        }
        e.preventDefault();
        e.stopPropagation();
        return;
    }
    if (fromBtnClick) {
        let currentRowIndex = current.parent().index();
        gridFocusCell(gridWidget, grid, currentCellIndex, currentRowIndex + 1);
    }
}

async function deleteRowAction(gridWidget, grid, dataItem, currentCellIndex) {
    addTask();
    let toBeDeletedId = dataItem.id;
    dataItem = grid.dataSource.data().filter(d => d.id === dataItem.id)[0];
    let row = grid.dataSource.data().indexOf(dataItem);
    if (row < 0)
        row = undefined;
    grid.dataSource.remove(dataItem);
    grid.dataSource.sync();
    let toBeRemoved = grid.dataSource.data().filter(item => item.masterRowId === toBeDeletedId);
    for (let dataItem of toBeRemoved) {
        grid.dataSource.remove(dataItem);
    }
    if (grid.dataSource.data().length == 0) {
        let uuid = await nextGUIDId();
        let ins = grid.dataSource.insert(0, {
            id: uuid
        });
    }
    updateModelLines(grid, gridWidget);
    let fieldMetaData = findFieldMetadata(gridWidget.id, gridWidget.owner.metaData);
    asyncGridAction(gridWidget, row, GridAction.DeleteLine, gridWidget.owner, fieldMetaData, dataItem);
    let wentToPrevious = false;
    if (!grid.current()) {
        grid.dataSource.page(grid.dataSource.page() - 1);
        wentToPrevious = true;
    }
    let rowsCount = grid.dataSource.data().length;
    if (rowsCount <= 0) {
        grid.dataSource.page(grid.dataSource.page() - 1);
        wentToPrevious = true;
    }
    if (gridWidget.popupEditor)
        wentToPrevious = true;
    let currentRowIndex = grid.dataSource.data().indexOf(dataItem);
    if (wentToPrevious || currentRowIndex >= rowsCount) {
        gridFocusCell(gridWidget, grid, currentCellIndex, ":last");
    } else {
        gridFocusCell(gridWidget, grid, currentCellIndex, ":eq(" + currentRowIndex + ")");
    }
    removeTask();
}

export async function deleteRow(e, grid, gridWidget) {
    if (!gridWidget.canDeleteRow())
        return;
    if (grid.dataSource.filter()) {
        notifier.showError(translateId("Delete not available with filter"));
        return;
    }
    if (!gridWidget.moreThanOneRowIsSelected()) {
        deleteRowAction(gridWidget, grid, grid.dataItem(grid.current().parent()), grid.current().index());
    } else {
        deleteSelectedRows(gridWidget, grid);
    }
}

export function deleteSelectedRows(gridWidget, grid) {
    let rows = gridWidget.findElement().find(".k-grid-content").find("table").find("tr.k-state-selected");
    let dataItems = [];
    for (let r of rows) {
        dataItems.push(grid.dataItem(r));
    }
    deleteMultiRows(gridWidget, grid, dataItems, 0);
}

function deleteMultiRows(gridWidget, grid, dataItems, counter) {
    for (; counter < dataItems.length;) {
        let dataItem = dataItems[counter];
        if (busy()) {
            setTimeout(() => {
                deleteMultiRows(gridWidget, grid, dataItems, counter);
            }, 200);
            return;
        }
        counter++;
        deleteRowAction(gridWidget, grid, dataItem, 0);
    }

}

export function updateModelLines(grid, gridWidget) {
    let details = [];
    for (let dataLine of grid.dataSource.data()) {
        let line = {};
        for (let key in dataLine) {
            if (dataLine.hasOwnProperty(key) && !(key === "_events" || key === "_handlers")) {
                line[key] = dataLine[key];
            }
        }
        details.push(line);
    }
    gridWidget.owner.setFieldValue(gridWidget.id, details);
}

export async function addLineAndCallGridAction(grid, currentRowAbsoluteIndex, gridWidget, rowViewIndex, copyLine, dataItemToCopy) {
    addTask();
    let uuid = await nextGUIDId();
    let dataItem = {};
    if (copyLine) {
        if (dataItemToCopy.toJSON)
            dataItem = dataItemToCopy.toJSON();
        else
            dataItem = dataItemToCopy;
        let fieldMetaData = findFieldMetadata(gridWidget.id, gridWidget.owner.metaData);
        if (isNotEmptyOrNull(fieldMetaData) && isNotEmptyOrNull(fieldMetaData.subFields)) {
            for (let i = 0; i < fieldMetaData.subFields.length; i++) {
                let subField = fieldMetaData.subFields[i];
                if (areNotEqual(subField.fieldType, "Binary"))
                    continue;
                setFieldValue(dataItem, subField.fieldId.substring(gridWidget.id.length + 1), null);
            }
        }
    }
    let dataItemClone = $.extend(true, {}, dataItem);
    dataItemClone.id = uuid;
    dataItemClone.g2Id = uuid;
    grid.dataSource.insert(currentRowAbsoluteIndex, dataItemClone);
    updateModelLines(grid, gridWidget);
    let fieldMetaData = findFieldMetadata(gridWidget.id, gridWidget.owner.metaData);
    if (copyLine)
        afterRowInserted(gridWidget, copyLine, rowViewIndex);
    else
        asyncGridAction(gridWidget, rowViewIndex, GridAction.InsertLine, gridWidget.owner, fieldMetaData);
    removeTask();

}

export function realLineKeys() {
    return ["_events", "_handlers", "id", "uid", "dirty", "dirtyFields", "parent", "g2Id"];
}

export async function appendRow(grid, insertAtEnd, gridWidget, ignoreEmptyLines, copyLine, dataItem, rowViewIndex, currentCellIndex) {
    if (!gridWidget.canAppendRow())
        return;
    if (grid.dataSource.filter())
        return;
    if (!dataItem)
        dataItem = grid.dataItem(grid.current().parent());
    if (!ignoreEmptyLines) {
        let realkeys = Object.keys(dataItem).removeAll(realLineKeys());
        if (!(realkeys.length))
            return;
    }
    let currentRowAbsoluteIndex = grid.dataSource.indexOf(dataItem);
    if (isNullOrUndefined(rowViewIndex))
        rowViewIndex = grid.current().parent().index();
    if (insertAtEnd) {
        rowViewIndex++;
        currentRowAbsoluteIndex++;
    }
    if (isNullOrUndefined(currentCellIndex))
        currentCellIndex = grid.current().index();
    await addLineAndCallGridAction(grid, currentRowAbsoluteIndex, gridWidget, rowViewIndex, copyLine, dataItem);
    if (rowViewIndex >= grid.dataSource.pageSize()) {
        grid.dataSource.page(grid.dataSource.page() + 1);
        rowViewIndex = 0;
    }
    gridFocusCell(gridWidget, grid, currentCellIndex, ":eq(" + rowViewIndex + ")", null, 1);
}

export function goToPreviousRow(gridWidget, e, grid, fromBtnClick) {
    let current = grid.current();
    let currentCellIndex = current.index();
    if (!current.parent().prev().length && grid.dataSource.page() > 1) {
        grid.dataSource.page(grid.dataSource.page() - 1);
        gridFocusCell(gridWidget, grid, currentCellIndex, ":last");
        e.preventDefault();
        e.stopPropagation();
        return;
    }
    if (fromBtnClick) {
        let currentRowIndex = current.parent().index();
        let newRowIndex = currentRowIndex === 0 ? 0 : currentRowIndex - 1;
        gridFocusCell(gridWidget, grid, currentCellIndex, newRowIndex);
    }
}

function onGridKeyPress(e) {
    let grid = nama.grid(this);
    if (currentTable(grid).find(".k-edit-cell").length > 0)
        return;
    grid.editCell(grid.current());
    grid.current().find(":input").val("");
}

export function letterORNumberKeyPressed(e) {
    if (e.keyCode >= 48 && e.keyCode <= 57)
        return true;
    if (e.keyCode >= 65 && e.keyCode <= 90)
        return true;
    if (e.keyCode >= 96 && e.keyCode <= 105)
        return true;
    return false;
}

export function onGridKeyDown(e, gridWidget) {
    let grid = gridWidget._kendoGrid();
    if (grid.dataSource.group().length > 0)
        return;
    if (currentTable(grid).find(".k-edit-cell").length > 0)
        return;
    let current = grid.current();
    if (!current.is("td"))
        return;
    if (e.keyCode === KeyboardKeyCode.F6) {
        e.preventDefault();
        e.stopPropagation();
        if (gridWidget.popupEditor)
            gridWidget.popupEditor.removeEditorPart();
        else
            openGridLineEditor(gridWidget, e);
    } else if (e.keyCode === kendo.keys.DELETE) {
        if (e.ctrlKey) {
            e.preventDefault();
            e.stopPropagation();
            deleteRow(e, grid, gridWidget);
        }
    }
}

export function onGridKeyUp(e, gridWidget) {
    let grid = gridWidget._kendoGrid();
    if (grid.dataSource.group().length > 0)
        return;
    if (currentTable(grid).find(".k-edit-cell").length > 0)
        return;
    if (e.keyCode === KeyboardKeyCode.F2) {
        e.preventDefault();
        e.stopPropagation();
        let columnId = e.target.attributes.columnId.value;
        let current = grid.current();
        let dataItem = grid.dataItem(current.parent());
        let rowIndex = gridWidget._getRowIndex(dataItem.id);
        let cell = gridWidget.fetchCell(rowIndex, columnId);
        grid.editCell(cell);
        return;
    } else if (letterORNumberKeyPressed(e)) {
        let gridElement = gridWidget.findElement();
        let curCell = gridElement.find(".k-state-focused");
        curCell.attr("typedKeys", e.key);
        gridElement.data('kendoGrid').editCell(curCell);
        return;
    }
    let current = grid.current();
    if (!current.is("td"))
        return;
    let evtObj = e;
    if (isKeyEventForBusinessFunction(evtObj, BusinessFunction.rowDown))
        goToNextRow(e, grid, gridWidget);
    else if (isKeyEventForBusinessFunction(evtObj, BusinessFunction.rowUp))
        goToPreviousRow(gridWidget, e, grid);
    else if (isKeyEventForBusinessFunction(evtObj, BusinessFunction.rowAppend))
        appendRow(grid, true, gridWidget);
    if (e.keyCode === 120) {
        let currentRowIndex = grid.current().parent().index();
        let colModelId = grid.current().attr("nama-col");
        let colId = gridWidget.id;
        if (colModelId)
            colId = colModelId.substring(1, colModelId.length).replaceAll("$", ".")
        showTooltip(gridWidget.owner.entityType, colId, currentRowIndex, gridWidget.owner, gridWidget.id);
    } else if (e.keyCode === kendo.keys.ENTER) {
        if (e.shiftKey) {
            let hasPreviousCells = current.prev("td").length;
            if (hasPreviousCells)
                gridFocusCell(gridWidget, grid, current.index() - 1);
            else
                goToPreviousRow(gridWidget, e, grid);
        } else {
            let hasNextCells = current.next("td").length;
            if (hasNextCells)
                gridFocusCell(gridWidget, grid, current.index() + 1);
            else
                goToNextRow(e, grid, gridWidget);
        }
    } else if (e.keyCode === kendo.keys.DOWN) {
        goToNextRow(e, grid, gridWidget);
    } else if (e.keyCode === kendo.keys.UP) {
        goToPreviousRow(gridWidget, e, grid);
    } else if (e.keyCode === kendo.keys.INSERT) {
        if (e.ctrlKey) {
            if (e.altKey)
                showMultiCopyDialog(grid, gridWidget);
            else {
                appendRow(grid, false, gridWidget);
            }
        } else if (e.shiftKey) {
            copyLinesAction(grid, gridWidget, 1);
        }
    } else if (e.keyCode === kendo.keys.PAGEDOWN) {
        grid.dataSource.page(grid.dataSource.page() + 1);
        gridFocusCell(gridWidget, grid, current.index());
        e.preventDefault();
        e.stopPropagation();
    } else if (e.keyCode === kendo.keys.PAGEUP && grid.dataSource.page() - 1 > 0) {
        grid.dataSource.page(grid.dataSource.page() - 1);
        gridFocusCell(gridWidget, grid, current.index(), ":last");
        e.preventDefault();
        e.stopPropagation();
    } else if (e.keyCode === kendo.keys.HOME) {
        goToFirstCell(gridWidget, e, grid);
    } else if (e.keyCode === kendo.keys.END) {
        goToLastCell(gridWidget, e, grid);
    }
}

export function openGridLineEditor(grid_, e) {
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }
    localStorage.setItem(gridKey(grid_), "true");
    let grid = grid_._kendoGrid();
    if (!grid.current())
        return;
    let rowIndex = grid.current().parent().index();
    if (grid_.findElement().attr("readonlyGrid") === "true" || grid_.allColumnsAreReadOnly(rowIndex))
        return;
    let dataItem = grid.dataItem(grid.current().parent());
    let popupEditor = grid_.popupEditor;
    if (!popupEditor)
        popupEditor = new NamaGridLineEditor(grid_, dataItem);
    popupEditor.show(dataItem, rowIndex);
}

function multiCopyLineAction(grid, gridWidget, copiesCount, row, cellIndex) {
    let dataItem = grid.dataItem(row);
    let rowIndex = row.index();
    multiCopyLine(grid, gridWidget, copiesCount, dataItem, rowIndex, cellIndex);
}

export function copyLinesAction(grid, gridWidget, copiesCount) {
    if (!gridWidget.moreThanOneRowIsSelected()) {
        multiCopyLineAction(grid, gridWidget, copiesCount, grid.current().parent(), grid.current().index());
    } else {
        let rows = gridWidget.findElement().find(".k-grid-content").find("table").find("tr.k-state-selected");
        for (let row of rows) {
            multiCopyLineAction(grid, gridWidget, copiesCount, $(row), 0);
        }
    }
}

export function showLabelsCountDialog(owner, entityType, callBack) {
    let window = new NamaKendoWindow("lablesCount", new NamaWindowBtnData("ok", () => {
        let copiesCount = widget.readValueFromElement();
        callBack(copiesCount);
        window.closeWindow();
    }), new NamaWindowBtnData("cancel"), "25%");

    let widget = new IntegerFieldWidget({owner: window});
    window.addDataWidget(widget.render());
    window.height = "12%";
    widget.afterAttach();
    widget.setValueInElement(1);
    window.showWindow();
}

export function showMultiCopyDialog(grid, gridWidget) {
    if (gridWidget.isCopyRowDisabled())
        return;
    showLabelsCountDialog(gridWidget.owner, gridWidget.entityType, (copiesCount) => copyLinesAction(grid, gridWidget, copiesCount));
}

function multiCopyLine(grid, gridWidget, copiesCount, dataItem, rowIndex, cellIndex) {
    let cb = (count) => {
        if (count <= 0)
            return;
        if (busy()) {
            setTimeout(() => cb(count), 100);
            return;
        }
        appendRow(grid, true, gridWidget, false, true, dataItem, rowIndex, cellIndex);
        multiCopyLine(grid, gridWidget, parseInt(count) - 1, dataItem, rowIndex, cellIndex);
    };
    cb(copiesCount);

}

function goToFirstCell(gridWidget, e, grid) {
    let current = grid.current();
    let currentCellIndex = current.index();
    grid.dataSource.page(0);
    gridFocusCell(gridWidget, grid, currentCellIndex, ":eq(0)");
    e.preventDefault();
    e.stopPropagation();
}

function goToLastCell(gridWidget, e, grid) {
    let current = grid.current();
    let currentCellIndex = current.index();
    let rowsCount = grid.dataSource.data().length - 1;
    grid.dataSource.page(grid.dataSource.totalPages());
    gridFocusCell(gridWidget, grid, currentCellIndex, ':eq(' + rowsCount + ')');
    e.preventDefault();
    e.stopPropagation();
}